import "./App.scss";
import Dictionary from "./components/Dictionary";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Dictionary />
      <Footer />
    </div>
  );
}

export default App;
